var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVerticalChartIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.0634 19.3388H0.03125V0.306641H0.978204V18.392H19.0634V19.3388ZM3.10283 10.3421H2.62935V16.7405H6.29811V10.3421C5.23316 10.3421 4.16799 10.3421 3.10283 10.3421ZM13.7431 2.43147H13.2698V16.7407H16.9386V2.43147C15.8734 2.43147 14.8082 2.43147 13.7431 2.43147ZM8.42294 6.38677H7.94946V16.7405H11.6182V6.38677C10.5533 6.38677 9.48811 6.38677 8.42294 6.38677Z",
    fill: "#4F6E90"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerticalChartIcon);
export default __webpack_public_path__ + "static/media/vertical-chart-icon.75a8ab0f8e6186d1f3cd1c6877fa9edf.svg";
export { ForwardRef as ReactComponent };